import React, { useState } from 'react';

const CustomImage = ({ src, className, altText = "" }) => {
    const [isBroken, setIsBroken] = useState(false);
    const [fallbackSrc, setFallbackSrc] = useState('');
    const ext = src?.toLowerCase().split('.').pop();
    const renditionMap = {
        zip: `${src}/jcr:content/renditions/mediakit-thumb.png`,
        jar: `${src}/jcr:content/renditions/mediakit-thumb.png`,
        jpeg: `${src}.wdthumb.1280.1280.png`,
        png: `${src}.wdthumb.1280.1280.png`,
        gif: `${src}.wdthumb.1280.1280.png`
    };

    if (!fallbackSrc) {
        setFallbackSrc(renditionMap[ext] || `${src}.wdthumb.1280.1280.png`);
    }

    const handleImageError = () => {
        if (!isBroken) {
            setIsBroken(true);
            setFallbackSrc(`${src}.wdthumb.1280.1280.png`);
        }
    };

    const fallbackAlt = altText?.length > 0 ? altText : "No Preview"

    return (
        <picture>
            {!src?.toLowerCase().endsWith('.zip') && !src?.toLowerCase().endsWith('.jar') && (
                <>
                    <source srcSet={`${src}.wdthumb.500.500.webp`}
				media="(min-width: 300px)" type="image/webp" />
            
			<source srcSet={`${src}${'.wdthumb.1280.1280.webp'}`}
				media="(min-width: 992px)" type="image/webp" />
			<source srcSet={`${src}${'.wdthumb.1280.1280.jpg'}`}
				media="(min-width: 992px)" type="image/jpeg" />
			<source srcSet={`${src}${'.wdthumb.1280.1280.png'}`}
				media="(min-width: 992px)" type="image/png" />

			<source srcSet={`${src}${'.wdthumb.500.500.webp'}`}
				media="(min-width: 500px)" type="image/webp" />
			<source srcSet={`${src}${'.wdthumb.500.500.jpg'}`}
				media="(min-width: 500px)" type="image/jpeg" />
			<source srcSet={`${src}${'.wdthumb.500.500.png'}`}
				media="(min-width: 500px)" type="image/png" />

			<source srcSet={`${src}${'.wdthumb.500.500.webp'}`}
				media="(min-width: 300px)" type="image/webp" />
			<source srcSet={`${src}${'.wdthumb.500.500.jpg'}`}
				media="(min-width: 300px)" type="image/jpeg" />
			<source srcSet={`${src}${'.wdthumb.500.500.png'}`}
				media="(min-width: 300px)" type="image/png" />
                </>
            )}

            <link fetchPriority="high" rel="preload" as="image" href={fallbackSrc} />
            <img
                src={fallbackSrc}
                alt={fallbackAlt}
                className={className}
                onError={handleImageError}
            />
        </picture>
    );
};

export default CustomImage;